import ContentLoader from 'react-content-loader';
import *as React from 'react';

export const NoteListingLoader= props  =>{
    return (
        <>
        {props.count && props.count > 0 && (
            Array.from({ length:props.count }, (_, i) => (
                <ContentLoader
                key={i+1}
                height={118}
                width={1051}
                speed={2}
            >
                {/* <rect x="8" y="5" rx="8" ry="8" width="60" height="12" />  */}
                <circle cx="34" cy="52" r="24" />
                <rect x="100" y="30" rx="8" ry="8" width="180" height="12" />
                <rect x="100" y="57" rx="8" ry="8" width="450" height="12" />
                <rect x="980" y="30" rx="8" ry="8" width="70" height="12" />
            </ContentLoader>
            ))
        )}
        </>
    )
}



